import { useLocation } from 'react-router-dom';
import { findNavMatch, labelForPath } from '@/nav/navigation';

/**
 * Stand-in for every nav destination that has no approved design yet.
 * Title and icon come from the nav tree, so a new nav entry gets a correctly
 * labelled page with no extra work.
 */
export function PlaceholderPage() {
  const location = useLocation();
  const { item } = findNavMatch(location.pathname);
  const Icon = item?.icon;
  const title = labelForPath(location.pathname);

  return (
    <div className="flex min-h-[calc(100vh-var(--topbar,72px))] items-center justify-center p-4 sm:p-6">
      <section className="w-full max-w-[496px] rounded-xl border border-line bg-white px-8 py-12 text-center shadow-card">
        {Icon && (
          <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-signal-50 text-signal">
            <Icon aria-hidden className="h-6 w-6" />
          </span>
        )}
        <h1 className="text-card-title text-ink">{title}</h1>
        <p className="mx-auto mt-2 max-w-[380px] text-sm leading-relaxed text-muted">
          This is a placeholder representing the core operational viewport. Explore the navigation items
          on the premium enterprise sidebar.
        </p>
      </section>
    </div>
  );
}
